import { addUtmToUrl } from '@/utils/utm';

export const wrapRouter = (router) => {
  const originalPush = router.push;
  const originalReplace = router.replace;

  router.push = function routerPushWrapper(location) {
    if (typeof location === 'string') {
      return originalPush.call(this, addUtmToUrl(location));
    } if (typeof location === 'object' && !('redirectedFrom' in location)) {
      const newLocation = { ...location };
      if (newLocation.path || newLocation.name) {
        const newPath = addUtmToUrl(
          newLocation.path || router.resolve(newLocation).href,
        );
        if (newLocation.path) newLocation.path = newPath;
      }
      return originalPush.call(this, newLocation);
    }
    return originalPush.call(this, location);
  };

  router.replace = function routerReplaceWrapper(location) {
    if (typeof location === 'string') {
      return originalReplace.call(this, addUtmToUrl(location));
    } if (typeof location === 'object') {
      const newLocation = { ...location };
      if (newLocation.path || newLocation.name) {
        const newPath = addUtmToUrl(
          newLocation.path || router.resolve(newLocation).href,
        );
        if (newLocation.path) newLocation.path = newPath;
      }
      return originalReplace.call(this, newLocation);
    }
    return originalReplace.call(this, location);
  };

  return router;
};
